/**
 * /app/$tenantSlug/comp-off — Manage › Leave › Comp-Off: grant a team
 * member a comp-off credit, look up their credits and (HR) revoke one
 * granted by mistake. Approvers only (a manager role, a direct report or a
 * live delegation — the same test the server applies); your own balance is
 * Me › Leave › Comp-Off.
 */

import { createFileRoute } from "@tanstack/react-router";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { LeaveFeatureGate } from "@/components/leave/leave-feature-gate";
import { useLeaveRoles } from "@/components/leave/use-leave-roles";
import { CompOffTeam } from "@/components/leave/comp-off-team";
import { EmptyState } from "@/components/shared/empty-state";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/comp-off")({
  component: TeamCompOffRoute,
});

function TeamCompOffRoute() {
  const { isApprover, isLeaveAdmin } = useLeaveRoles();

  return (
    <TimeAndLeaveShell
      title="Comp-Off"
      description="Grant comp-off to someone who worked a holiday or weekly off, and look up their credits."
    >
      <LeaveFeatureGate>
        {isApprover ? (
          <CompOffTeam canRevoke={isLeaveAdmin} />
        ) : (
          <EmptyState title="Only people who approve leave can grant comp-off." />
        )}
      </LeaveFeatureGate>
    </TimeAndLeaveShell>
  );
}
